import React from "react";
import { Section } from "./Elements/Section";
import { Card } from "./Elements/Card";

const industries = [
  { title: "Fintech", copy: "Payments, KYC, AML, and secure data platforms." },
  {
    title: "Healthcare",
    copy: "HIPAA-aware systems, scheduling, tele‑health, analytics.",
  },
  { title: "Retail & D2C", copy: "Headless commerce, OMS, personalization." },
  {
    title: "Logistics",
    copy: "Fleet tracking, routing, real-time ops dashboards.",
  },
  {
    title: "SaaS & Platforms",
    copy: "Multi-tenant architectures, billing, self‑serve onboarding.",
  },
  {
    title: "Gov & Public",
    copy: "Scalable citizen services with accessibility-first design.",
  },
];

export const Industries = () => {
  return (
    <Section
      id="industries"
      eyebrow="Where we play"
      title="Industries"
      subtitle="Experience that shortens discovery and de‑risks delivery."
    >
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {industries.map((i) => (
          <Card key={i.title}>
            <div className="flex items-center justify-between">
              <h3 className="font-semibold text-gray-900">{i.title}</h3>
              <span className="text-xs rounded-full bg-gray-100 px-2 py-1">
                Case studies
              </span>
            </div>
            <p className="mt-2 text-sm text-gray-600">{i.copy}</p>
          </Card>
        ))}
      </div>
    </Section>
  );
};
